import store from '../store/store';
import {sunHours} from './';

var s = (store.getState()).formData;

export function calculateDailyProduction() {
    return s.systemSize * sunHours[s.officeName];
}

export function calculateDailyUsage() {
    return calculateDailyProduction() * (s.daytimeUsage / 100);
}

export function calculateDailyExport() {
    return calculateDailyProduction() - calculateDailyUsage();
}